import React from "react"
import { Icon, IconButton } from "native-base"
import { Ionicons, MaterialCommunityIcons, FontAwesome5 } from "@expo/vector-icons";
import { IDisposer, onPatch } from "mobx-state-tree";
import { useFocusEffect } from "@react-navigation/native";
import { ITEM_STATUS } from "../../../voolks/types";
import { isElementArchived, openPDF } from "../../../utils/itemCommonFunctions";
import { useDebounce, useDebouncedCallback } from "use-debounce";
import { customApp } from "../../../config";



export const GetActionButtonsFC = ({ itemsStore, navigation, setShouldHide, pageActive, form, saveAndGo, forReview }) => {
  const [isValidItem, setIsValidItem] = React.useState<boolean>(false);
  console.log("ItemDetailsScreen", "GetActionButtonsFc", "isValidItem", isValidItem, "pageActive", pageActive); 
  const validateItem = () => {
    if (forReview == false && form.pages.length == (pageActive + 1)) {
      console.log("GetActionButtonsFC", "validateItem");
      let isvalid: boolean = true;
      for (const key of itemsStore.itemActive.payload?.keys()) {
        let isArchived: boolean = form.pages.reduce((isArchived, page) => {
          return isElementArchived(page.fields, key, isArchived);
        }, false);
        let element = itemsStore.itemActive.payload.get(key).toJSON();
        if (!(isArchived || (element.inactiveGroup == true))) {
          console.log(key,form.pages[0].fields.find(a=>a.id==key)?.type,form.pages[0].fields.find(a=>a.id==key)?.name,element.inactiveGroup,element.valid,element.value)
          isvalid = (isvalid ? element?.valid == true : isvalid);
        }
        //
      }
      isValidItem != isvalid && setIsValidItem(isvalid);
    }

  }
  const validateItemDebounced = useDebouncedCallback(validateItem, 500);
  const ItemsListScreenName = customApp.isPTW ? "PTWHome" : "ItemsList";
  useFocusEffect(() => {
    setShouldHide(false);
    validateItem();
    if (forReview != true) {
      let _disposerOnPatch: IDisposer
      _disposerOnPatch = onPatch(itemsStore, patch => {
        validateItemDebounced();
      })
      return () => {
        setShouldHide(true)
        _disposerOnPatch();
        _disposerOnPatch = undefined
      }
    }
    return undefined;
  });


  const itemStatus = itemsStore.itemActive.status;
  const upload = async () => {
    await itemsStore.upload({ itemIDX: itemsStore.itemActiveIDX });
    saveAndGo();
  }
  if (itemStatus == ITEM_STATUS.draft) {
    if (pageActive != (form.pages.length - 1))
      return <IconButton variant="solid" key="actionButton-checkHidden" isDisabled
        icon={<Icon as={Ionicons} name="checkmark" size="xl" color="red.400" />}
      />;
    if (forReview == false)
      return <IconButton variant="solid" key="actionButton-saveToPreview" isDisabled={!isValidItem}
        icon={<Icon as={Ionicons} name="checkmark" size="xl" />}
        onPress={() => saveAndGo({ goTo: "ItemDetails", forReview: true })}
      />;
    if (forReview == true)
      return <IconButton variant="solid" key="actionButton-closeItem"
        icon={<Icon as={Ionicons} name="lock-closed" size="xl" />}
        onPress={() => saveAndGo({ goTo: ItemsListScreenName, itemStatus: ITEM_STATUS.closed, forReview: true })}
      />;
  }

  if (itemStatus == ITEM_STATUS.closed) {
    return <><IconButton variant="solid" isDisabled={itemsStore.itemActive.readOnly == true}
      icon={<Icon key="actionButton-openItem" as={Ionicons} name="lock-open" size="xl" />}
      onPress={() => saveAndGo({ goTo: "ItemDetails", itemStatus: ITEM_STATUS.draft, forReview: false })}
    /><IconButton variant="solid" key="actionButton-uploadItem"
      icon={<Icon as={MaterialCommunityIcons} name="cloud-upload" size="xl" />}
      onPress={upload}
      /></>;
  }

  if (itemStatus == ITEM_STATUS.sent) {
    return <><IconButton variant="solid"
      icon={<Icon as={Ionicons} name="mail" size="xl" />}
      onPress={() => openPDF(itemsStore, itemsStore.itemActive, true)}
    /><IconButton variant="solid"
      icon={<Icon as={FontAwesome5} name="file-pdf" size="xl"/>}
      onPress={() => openPDF(itemsStore, itemsStore.itemActive)}
      /></>;
  }
  return <></>;
};